// This is a copy of existing enum from `rcds-db-entities`
// N.B. STATES MAY HAVE BEEN ADDED OR REMOVED
export enum CheckboardOTPStateEnum {
  SENT = 29,
  RE_SENT = 30,
  INCORRECT = 31,
  CONFIRMED = 32,
  REQUEST_FAILED = 34,
}